<template>
  <div class="shainSettei">
    <el-card id="shainCard" class="card">
      <el-form ref="form" :model="form" :rules="rules" label-width="110px" v-loading="loading" size="medium">
        <el-form-item label="社員氏名" prop="shainShimei">
          <el-input v-model="form.shainShimei" maxlength="22"></el-input>
        </el-form-item>
        <el-form-item label="基準始業時刻" prop="kijunShigyoJikoku">
          <el-input v-model="form.kijunShigyoJikoku" type="time" @change="onChangeKijun"></el-input>
        </el-form-item>
        <el-form-item label="基準終業時刻" prop="kijunShugyoJikoku">
          <el-input v-model="form.kijunShugyoJikoku" type="time" @change="onChangeKijun"></el-input>
        </el-form-item>
        <el-form-item label="昼食開始時刻" prop="chushokuKaishiJikoku">
          <el-input v-model="form.chushokuKaishiJikoku" type="time" @change="onChangeKijun"></el-input>
        </el-form-item>
        <el-form-item label="昼食終了時刻" prop="chushokuShuryoJikoku">
          <el-input v-model="form.chushokuShuryoJikoku" type="time" @change="onChangeKijun"></el-input>
        </el-form-item>
        <el-form-item label="休憩開始時刻" prop="kyukeiKaishiJikoku">
          <el-input v-model="form.kyukeiKaishiJikoku" type="time"></el-input>
        </el-form-item>
        <el-form-item label="休憩終了時刻" prop="kyukeiShuryoJikoku">
          <el-input v-model="form.kyukeiShuryoJikoku" type="time"></el-input>
        </el-form-item>
        <el-form-item v-if="form.shainKubun=='3'" label="実働契約時間">
          <el-input v-model="form.jitsudoKeiyakuJikan" maxlength="4" class="number-input" readonly></el-input> H
          <div>※基準時刻から自動計算</div>
        </el-form-item>
        <el-form-item v-if="form.shainKubun=='4'" label="基本契約時間">
          <el-input v-model="form.kihonKeiyakuJikanFrom" maxlength="3" class="number-input"></el-input> H ～ 
          <el-input v-model="form.kihonKeiyakuJikanTo" maxlength="3" class="number-input"></el-input> H
        </el-form-item>
        <el-form-item v-if="isGenechMailUser" label="上長ﾒｰﾙｱﾄﾞﾚｽ1" prop="jochoShainId" :error="errors.jochoShainId">
          <el-input v-model="form.jochoShainId" maxlength="50" class="wide-input"></el-input>
        </el-form-item>
        <el-form-item v-if="isGenechMailUser" label="上長ﾒｰﾙｱﾄﾞﾚｽ2" prop="jochoShainId2" :error="errors.jochoShainId2">
          <el-input v-model="form.jochoShainId2" maxlength="50" class="wide-input"></el-input>
        </el-form-item>
        <el-form-item v-if="isGenechMailUser" label="上長ﾒｰﾙｱﾄﾞﾚｽ3" prop="jochoShainId3" :error="errors.jochoShainId3">
          <el-input v-model="form.jochoShainId3" maxlength="50" class="wide-input"></el-input>
        </el-form-item>
        <el-form-item label="営業ﾒｰﾙｱﾄﾞﾚｽ1" prop="eigyoShainId" :error="errors.eigyoShainId">
          <el-input v-model="form.eigyoShainId" maxlength="50" class="wide-input"></el-input>
        </el-form-item>
        <el-form-item label="営業ﾒｰﾙｱﾄﾞﾚｽ2" prop="eigyoShainId2" :error="errors.eigyoShainId2">
          <el-input v-model="form.eigyoShainId2" maxlength="50" class="wide-input"></el-input>
        </el-form-item>
        <el-form-item label="営業ﾒｰﾙｱﾄﾞﾚｽ3" prop="eigyoShainId3" :error="errors.eigyoShainId3">
          <el-input v-model="form.eigyoShainId3" maxlength="50" class="wide-input"></el-input>
        </el-form-item>
        <el-form-item label="リモート既定値" prop="defaultRemoteFlag">
          <el-checkbox v-model="form.defaultRemoteFlag" label="リモート" :border="true"></el-checkbox>
        </el-form-item>
        <el-form-item label="定期代" prop="teikiHitsuyoFlag">
          <el-checkbox v-model="form.teikiHitsuyoFlag" label="必要" :border="true"></el-checkbox>
        </el-form-item>
        <el-form-item label="交通機関名1" prop="kotsuKikanMei1">
          <el-input v-model="form.kotsuKikanMei1" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="通勤ルート1" prop="tsukinRoute1">
          <el-input v-model="form.tsukinRoute1" maxlength="30" class="wide-input"></el-input>
        </el-form-item>
        <el-form-item label="通勤交通費1" prop="tsukinKotsuhi1">
          <el-input v-model="form.tsukinKotsuhi1" maxlength="6" placeholder="※往復金額" class="narrow-input"></el-input>
        </el-form-item>
        <el-form-item label="交通機関名2" prop="kotsuKikanMei2" v-show="tsukinRouteCount >= 2">
          <el-input v-model="form.kotsuKikanMei2" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="通勤ルート2" prop="tsukinRoute2" v-show="tsukinRouteCount >= 2">
          <el-input v-model="form.tsukinRoute2" maxlength="30" class="wide-input"></el-input>
        </el-form-item>
        <el-form-item label="通勤交通費2" prop="tsukinKotsuhi2" v-show="tsukinRouteCount >= 2">
          <el-input v-model="form.tsukinKotsuhi2" maxlength="6" placeholder="※往復金額" class="narrow-input"></el-input>
        </el-form-item>
        <el-form-item label="交通機関名3" prop="kotsuKikanMei3" v-show="tsukinRouteCount >= 3">
          <el-input v-model="form.kotsuKikanMei3" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="通勤ルート3" prop="tsukinRoute3" v-show="tsukinRouteCount >= 3">
          <el-input v-model="form.tsukinRoute3" maxlength="30" class="wide-input"></el-input>
        </el-form-item>
        <el-form-item label="通勤交通費3" prop="tsukinKotsuhi3" v-show="tsukinRouteCount >= 3">
          <el-input v-model="form.tsukinKotsuhi3" maxlength="6" placeholder="※往復金額" class="narrow-input"></el-input>
        </el-form-item>
        <el-form-item label="交通機関名4" prop="kotsuKikanMei4" v-show="tsukinRouteCount >= 4">
          <el-input v-model="form.kotsuKikanMei4" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="通勤ルート4" prop="tsukinRoute4" v-show="tsukinRouteCount >= 4">
          <el-input v-model="form.tsukinRoute4" maxlength="30" class="wide-input"></el-input>
        </el-form-item>
        <el-form-item label="通勤交通費4" prop="tsukinKotsuhi4" v-show="tsukinRouteCount >= 4">
          <el-input v-model="form.tsukinKotsuhi4" maxlength="6" placeholder="※往復金額" class="narrow-input"></el-input>
        </el-form-item>
        <el-form-item label="交通機関名5" prop="kotsuKikanMei5" v-show="tsukinRouteCount >= 5">
          <el-input v-model="form.kotsuKikanMei5" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="通勤ルート5" prop="tsukinRoute5" v-show="tsukinRouteCount >= 5">
          <el-input v-model="form.tsukinRoute5" maxlength="30" class="wide-input"></el-input>
        </el-form-item>
        <el-form-item label="通勤交通費5" prop="tsukinKotsuhi5" v-show="tsukinRouteCount >= 5">
          <el-input v-model="form.tsukinKotsuhi5" maxlength="6" placeholder="※往復金額" class="narrow-input"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="addRoute()" :disabled="tsukinRouteCount >= 5">経路追加</el-button>
        </el-form-item>
        <el-form-item v-if="isRomu">
          <div style="color: red; margin-bottom: -15px;">安否確認連絡先</div>
        </el-form-item>
        <el-form-item v-if="isRomu" label="安否ﾒｰﾙｱﾄﾞﾚｽ1" prop="bcpCompanyEmail">
          <el-input v-model="form.bcpCompanyEmail" maxlength="128" class="wide-input"></el-input>
        </el-form-item>
        <el-form-item v-if="isRomu" label="安否ﾒｰﾙｱﾄﾞﾚｽ2" prop="bcpPrivateEmail">
          <el-input v-model="form.bcpPrivateEmail" maxlength="128" class="wide-input"></el-input>
        </el-form-item>
        <el-form-item v-if="isRomu" label="安否電話番号" prop="bcpPrivatePhone">
          <el-input v-model="form.bcpPrivatePhone" maxlength="13"></el-input>
          <div style="line-height: 20px;">※SMSが受信できる番号<br/>※ハイフンなしで入力</div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onRegister('form')">登録</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { notifySuccess, notifyError } from '../utils.js'

export default {
  name: 'KimmuJissekiK',
  data() {
    return {
      form: {
        shainKubun: '3',
        shainShimei: '',
        shainBango: '',
        kijunShigyoJikoku: '',
        kijunShugyoJikoku: '',
        chushokuKaishiJikoku: '',
        chushokuShuryoJikoku: '',
        kyukeiKaishiJikoku: '',
        kyukeiShuryoJikoku: '',
        jitsudoKeiyakuJikan: '',
        kihonKeiyakuJikanFrom: '',
        kihonKeiyakuJikanTo: '',
        jochoShainId: '',
        jochoShainId2: '',
        jochoShainId3: '',
        eigyoShainId: '',
        eigyoShainId2: '',
        eigyoShainId3: '',
        defaultRemoteFlag: false,
        teikiHitsuyoFlag: false,
        kotsuKikanMei1: '',
        tsukinRoute1: '',
        tsukinKotsuhi1: 0,
        kotsuKikanMei2: '',
        tsukinRoute2: '',
        tsukinKotsuhi2: 0,
        kotsuKikanMei3: '',
        tsukinRoute3: '',
        tsukinKotsuhi3: 0,
        kotsuKikanMei4: '',
        tsukinRoute4: '',
        tsukinKotsuhi4: 0,
        kotsuKikanMei5: '',
        tsukinRoute5: '',
        tsukinKotsuhi5: 0,
        bcpCompanyEmail: '',
        bcpPrivateEmail: '',
        bcpPrivatePhone: '',
      },
      errors: {
        jochoShainId: '',
        jochoShainId2: '',
        jochoShainId3: '',
        eigyoShainId: '',
        eigyoShainId2: '',
        eigyoShainId3: '',
      },
      rules: {
        shainShimei: [
          { required: true, message: '入力してください。', trigger: 'blur' }
        ],
        kijunShigyoJikoku: [
          { required: true, message: '入力してください。', trigger: 'blur' }
        ],
        kijunShugyoJikoku: [
          { required: true, message: '入力してください。', trigger: 'blur' }
        ],
        kijunChushokuJikan: [
          { required: true, message: '入力してください。', trigger: 'blur' }
        ],
        kijunKyukeiJikan: [
          { required: true, message: '入力してください。', trigger: 'blur' }
        ],
        zangyoTani: [
          { required: true, message: '入力してください。', trigger: 'blur' }
        ],
        tsukinKotsuhi1: [
          { pattern: /^[0-9]*$/, message: '数値を入力してください。' }
        ],
        tsukinKotsuhi2: [
          { pattern: /^[0-9]*$/, message: '数値を入力してください。' }
        ],
        tsukinKotsuhi3: [
          { pattern: /^[0-9]*$/, message: '数値を入力してください。' }
        ],
        tsukinKotsuhi4: [
          { pattern: /^[0-9]*$/, message: '数値を入力してください。' }
        ],
        tsukinKotsuhi5: [
          { pattern: /^[0-9]*$/, message: '数値を入力してください。' }
        ],
        bcpCompanyEmail: [
          { pattern: /.+@.+/, message: 'ﾒｰﾙｱﾄﾞﾚｽを入力してください。' }
        ],
        bcpPrivateEmail: [
          { pattern: /.+@.+/, message: 'ﾒｰﾙｱﾄﾞﾚｽを入力してください。' }
        ],
        bcpPrivatePhone: [
          { pattern: /^[0-9]*$/, message: '数字を入力してください。' }
        ],
      },
      loading: true,
      tsukinRouteCount: 1,
      apiSubPath: "",
    }
  },
  computed: {
    isGenechMailUser() {
      return this.$parent.isGenechMailUser();
    },
    isRomu() {
      let kengenKubun = this.$parent.getKengenKubun();
      return (kengenKubun >= '700');
    },
  },
  created() {
    if (location.href.includes('/k/')) {
      this.apiSubPath = '/k';
    }
    this.getData();
  },
  methods: {
    addRoute() {
      this.tsukinRouteCount++;
    },
    onChangeKijun() {
      if (this.form.shainKubun != '3' || !this.form.kijunShigyoJikoku || !this.form.kijunShugyoJikoku) {
        this.form.jitsudoKeiyakuJikan = '';
        return;
      }
      const dateSrting = '2000/01/01 ';
      const kijunShigyoJikoku = this.$moment(dateSrting + this.form.kijunShigyoJikoku);
      const kijunShugyoJikoku = this.$moment(dateSrting + this.form.kijunShugyoJikoku);
      const rodoJikan = kijunShugyoJikoku.diff(kijunShigyoJikoku, 'hours', true);
      const chushokuKaishiJikoku = this.$moment(dateSrting + this.form.chushokuKaishiJikoku);
      const chushokuShuryoJikoku = this.$moment(dateSrting + this.form.chushokuShuryoJikoku);
      let chusyokuJikan = 0;
      if (chushokuKaishiJikoku.isValid() && chushokuShuryoJikoku.isValid()) {
        chusyokuJikan = chushokuShuryoJikoku.diff(chushokuKaishiJikoku, 'hours', true);
      }
      this.form.jitsudoKeiyakuJikan = Math.round((rodoJikan - chusyokuJikan) * 100) / 100;
    },
    getData() {
      this.loading = true;
      let url = this.apiSubPath + '/gwr/shain/shain';
      this.$axios.get(url)
          .then((response) => {
            this.form.shainKubun = response.data.shainKubun;
            this.form.shainId = response.data.shainId;
            this.form.shainShimei = response.data.shainShimei;
            this.form.shainBango = response.data.shainBango;
            this.form.kijunShigyoJikoku = response.data.kijunShigyoJikoku;
            this.form.kijunShugyoJikoku = response.data.kijunShugyoJikoku;
            this.form.chushokuKaishiJikoku = response.data.chushokuKaishiJikoku;
            this.form.chushokuShuryoJikoku = response.data.chushokuShuryoJikoku;
            this.form.kyukeiKaishiJikoku = response.data.kyukeiKaishiJikoku;
            this.form.kyukeiShuryoJikoku = response.data.kyukeiShuryoJikoku;
            this.form.jitsudoKeiyakuJikan = response.data.jitsudoKeiyakuJikan;
            this.form.kihonKeiyakuJikanFrom = response.data.kihonKeiyakuJikanFrom;
            this.form.kihonKeiyakuJikanTo = response.data.kihonKeiyakuJikanTo;
            this.form.jochoShainId = response.data.jochoShainId;
            this.form.jochoShainId2 = response.data.jochoShainId2;
            this.form.jochoShainId3 = response.data.jochoShainId3;
            this.form.eigyoShainId = response.data.eigyoShainId;
            this.form.eigyoShainId2 = response.data.eigyoShainId2;
            this.form.eigyoShainId3 = response.data.eigyoShainId3;
            this.form.defaultRemoteFlag = response.data.defaultRemoteFlag;
            this.form.teikiHitsuyoFlag = response.data.teikiHitsuyoFlag;
            this.form.kotsuKikanMei1 = response.data.kotsuKikanMei1;
            this.form.tsukinRoute1 = response.data.tsukinRoute1;
            this.form.tsukinKotsuhi1 = response.data.tsukinKotsuhi1;
            this.form.kotsuKikanMei2 = response.data.kotsuKikanMei2;
            this.form.tsukinRoute2 = response.data.tsukinRoute2;
            this.form.tsukinKotsuhi2 = response.data.tsukinKotsuhi2;
            this.form.kotsuKikanMei3 = response.data.kotsuKikanMei3;
            this.form.tsukinRoute3 = response.data.tsukinRoute3;
            this.form.tsukinKotsuhi3 = response.data.tsukinKotsuhi3;
            this.form.kotsuKikanMei4 = response.data.kotsuKikanMei4;
            this.form.tsukinRoute4 = response.data.tsukinRoute4;
            this.form.tsukinKotsuhi4 = response.data.tsukinKotsuhi4;
            this.form.kotsuKikanMei5 = response.data.kotsuKikanMei5;
            this.form.tsukinRoute5 = response.data.tsukinRoute5;
            this.form.tsukinKotsuhi5 = response.data.tsukinKotsuhi5;
            if (this.form.kotsuKikanMei5) {
              this.tsukinRouteCount = 5;
            } else if (this.form.kotsuKikanMei4) {
              this.tsukinRouteCount = 4;
            } else if (this.form.kotsuKikanMei3) {
              this.tsukinRouteCount = 3;
            } else if (this.form.kotsuKikanMei2) {
              this.tsukinRouteCount = 2;
            } else {
              this.tsukinRouteCount = 1;
            }
            this.form.bcpCompanyEmail = response.data.bcpCompanyEmail;
            this.form.bcpPrivateEmail = response.data.bcpPrivateEmail;
            this.form.bcpPrivatePhone = response.data.bcpPrivatePhone;
            this.loading = false;
          })
          .catch((error) => {
            notifyError(this, error, 'データ取得エラー', '', true);
          });
    },
    validateJocho: async function(shainId) {
      let result = false;
      this.loading = true;
      try {
        let url = this.apiSubPath + '/gwr/shain/validateJocho/' + shainId;
        let response = await this.$axios.get(url);
        result = response.data;
      }
      catch (error) {
        notifyError(this, error, 'データ取得エラー', '', true);
      }
      this.loading = false;
      return result;
    },
    onRegister(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.errors = {
            jochoShainId: '',
            jochoShainId2: '',
            jochoShainId3: '',
            eigyoShainId: '',
            eigyoShainId2: '',
            eigyoShainId3: '',
          }
          let hasError = false;
          if (this.form.jochoShainId && !(await this.validateJocho(this.form.jochoShainId))) {
            this.errors.jochoShainId = '登録されていないアドレスです。';
            hasError = true;
          }
          if (this.form.jochoShainId2 && !(await this.validateJocho(this.form.jochoShainId2))) {
            this.errors.jochoShainId2 = '登録されていないアドレスです。';
            hasError = true;
          }
          if (this.form.jochoShainId3 && !(await this.validateJocho(this.form.jochoShainId3))) {
            this.errors.jochoShainId3 = '登録されていないアドレスです。';
            hasError = true;
          }
          if (this.form.eigyoShainId && !(await this.validateJocho(this.form.eigyoShainId))) {
            this.errors.eigyoShainId = '登録されていないアドレスです。';
            hasError = true;
          }
          if (this.form.eigyoShainId2 && !(await this.validateJocho(this.form.eigyoShainId2))) {
            this.errors.eigyoShainId2 = '登録されていないアドレスです。';
            hasError = true;
          }
          if (this.form.eigyoShainId3 && !(await this.validateJocho(this.form.eigyoShainId3))) {
            this.errors.eigyoShainId3 = '登録されていないアドレスです。';
            hasError = true;
          }
          if (hasError) {
            this.$notify({
              title: '入力エラー',
              message: '入力欄に表示されているエラー内容を確認してください。',
              type: 'error'
            });
            return;
          }
          this.loading = true;
          let params = new URLSearchParams(this.form);
          params.set('chushokuKaishiJikoku', this.form.chushokuKaishiJikoku ?? '');
          params.set('chushokuShuryoJikoku', this.form.chushokuShuryoJikoku ?? '');
          params.set('kyukeiKaishiJikoku', this.form.kyukeiKaishiJikoku ?? '');
          params.set('kyukeiShuryoJikoku', this.form.kyukeiShuryoJikoku ?? '');
          params.set('jitsudoKeiyakuJikan', this.form.jitsudoKeiyakuJikan ?? '');
          params.set('kihonKeiyakuJikanFrom', this.form.kihonKeiyakuJikanFrom ?? '');
          params.set('kihonKeiyakuJikanTo', this.form.kihonKeiyakuJikanTo ?? '');
          params.set('jochoShainId', this.form.jochoShainId ?? '');
          params.set('jochoShainId2', this.form.jochoShainId2 ?? '');
          params.set('jochoShainId3', this.form.jochoShainId3 ?? '');
          params.set('eigyoShainId', this.form.eigyoShainId ?? '');
          params.set('eigyoShainId2', this.form.eigyoShainId2 ?? '');
          params.set('eigyoShainId3', this.form.eigyoShainId3 ?? '');
          params.set('defaultRemoteFlag', this.form.defaultRemoteFlag ?? false);
          params.set('teikiHitsuyoFlag', this.form.teikiHitsuyoFlag ?? false);
          params.set('kotsuKikanMei1', this.form.kotsuKikanMei1 ?? '');
          params.set('tsukinRoute1', this.form.tsukinRoute1 ?? '');
          params.set('tsukinKotsuhi1', this.form.tsukinKotsuhi1 ?? '');
          params.set('kotsuKikanMei2', this.form.kotsuKikanMei2 ?? '');
          params.set('tsukinRoute2', this.form.tsukinRoute2 ?? '');
          params.set('tsukinKotsuhi2', this.form.tsukinKotsuhi2 ?? '');
          params.set('kotsuKikanMei3', this.form.kotsuKikanMei3 ?? '');
          params.set('tsukinRoute3', this.form.tsukinRoute3 ?? '');
          params.set('tsukinKotsuhi3', this.form.tsukinKotsuhi3 ?? '');
          params.set('kotsuKikanMei4', this.form.kotsuKikanMei4 ?? '');
          params.set('tsukinRoute4', this.form.tsukinRoute4 ?? '');
          params.set('tsukinKotsuhi4', this.form.tsukinKotsuhi4 ?? '');
          params.set('kotsuKikanMei5', this.form.kotsuKikanMei5 ?? '');
          params.set('tsukinRoute5', this.form.tsukinRoute5 ?? '');
          params.set('tsukinKotsuhi5', this.form.tsukinKotsuhi5 ?? '');
          params.set('bcpCompanyEmail', this.form.bcpCompanyEmail ?? '');
          params.set('bcpPrivateEmail', this.form.bcpPrivateEmail ?? '');
          params.set('bcpPrivatePhone', this.form.bcpPrivatePhone ?? '');
          let url = this.apiSubPath + '/gwr/shain/shain';
          this.$axios.post(url, params)
              .then(() => {
                notifySuccess(this, '登録完了', '社員設定を登録しました。');
                this.$parent.setJochoShainIds(this.form);
                this.$parent.enableMenu();
                this.$parent.switchMenu('KimmuJissekiK', '/kimmu');
              })
              .catch((error) => {
                notifyError(this, error, '登録エラー', '', true);
              });
        } else {
          return false;
        }
      });
    },
  },
}
</script>

<style scoped>
.card {
  width: 340px;
  margin: auto;
}
.el-form-item {
  text-align: left;
}
.el-input {
  width: 135px !important;
}
.wide-input {
  width: 190px !important;
}
.narrow-input {
  width: 100px !important;
}
.el-date-editor {
  width: 135px !important;
}
.el-input-number {
  width: 135px !important;
}
#shainCard >>> .el-input__inner {
  font-family: inherit !important;
}
#shainBango {
  height: 0px;
  margin-bottom: 0px;
}
#kengenKubun {
  height: 0px;
  margin-bottom: 0px;
}
#shainKubun {
  height: 0px;
  margin-bottom: 0px;
}
</style>
